import { userApi } from "../../config";

type AuthToken = {
  token: string;
}

type PhoneLoginResponse = {
  success: boolean;
  token?: string;
  user?: any;
  message?: string;
};

export async function signupApi(formData: Object) {
  try {
    const response = await userApi.post<AuthToken>('/user-register', formData);
    return { data: response.data, token: response.data.token };
  } catch (error: any) {
    if (error.response) {
      return { message: error.response.data.message || 'Unknown error' };
    } else if (error.request) {
      return { message: 'No response received from server' };
    } else {
      return { message: `Error occurred: ${error.message}` };
    }
  }
}

export async function mentorRegisterApi(formData: any) {
  try {
    const { adminApi } = await import("../../config");
    const response = await adminApi.post<{ token: string }>('/mentor-register', formData);
    return { data: response.data, token: response.data.token };
  } catch (error: any) {
    if (error.response) {
      return { message: error.response.data.message || 'Unknown error' };
    } else if (error.request) {
      return { message: 'No response received from server' };
    } else {
      return { message: `Error occurred: ${error.message}` };
    }
  }
}


export async function loginApi(formData: Object) {
  try {
    const response = await userApi.post<AuthToken>('/user-login', formData);
    if (response.status) return { "success": response.data, "token": response.data.token };
  } catch (err: any) {
    if (err.response) {
      return { message: err.response.data.message || 'Unknown error' }
    } else if (err.request) {
      return { message: "No response received from server" }
    } else {
      return { message: "Login Error Please Reload The Page! or try again." };
    }
  }
}


export async function googleLoginApi(credential: any) {
  try {
    const res = await userApi.post<AuthToken>('/google-login', {}, { headers: { 'Authorization': `Bearer ${credential}` } });
    if (res.status === 200) {
      return { "success": true, token: res.data.token };
    }
  } catch (err) {
  }
}


// Add phone login API function
export async function phoneLoginApi(phone: string): Promise<PhoneLoginResponse> {
  try {
    const response = await userApi.post<PhoneLoginResponse>('/phone-login', { phone });
    
    if (response.status === 200) {
      return {
        success: true,
        token: response.data.token,
        user: response.data.user,
        message: response.data.message
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Phone login failed'
      };
    }
  } catch (error: any) {
    console.error("Phone login error:", error);
    
    if (error.response) {
      return {
        success: false,
        message: error.response.data?.message || 'Phone login failed'
      };
    } else if (error.request) {
      return {
        success: false,
        message: 'No response received from server'
      };
    } else {
      return {
        success: false,
        message: `Error occurred: ${error.message}`
      };
    }
  }
}